import { render } from "./BasicRadio.vue?vue&type=template&id=8e4f1b2a&scoped=true&ts=true"
import script from "./BasicRadio.vue?vue&type=script&lang=ts"
export * from "./BasicRadio.vue?vue&type=script&lang=ts"

import "./BasicRadio.vue?vue&type=style&index=0&id=8e4f1b2a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4f1b2a"]])

export default __exports__